import { handleActions } from 'redux-actions'

import {
  changeCountry,
  changeZone,
  changeStatus,
  changeProduct,
  changeType,
  changeShipTo,
  changeTankId,
  changeGeoZones,
  changeCustomer,
  updateOriginalResult,
  updateFilteredResult,
} from './actions'
import { Error } from 'types'

export const INITIAL_STATE = {
  sh: '',
  tankId: '',
  customer: '',
  status: '',
  product: '',
  type: '',
  geoZone: '',
  country: '',
  zone: '',
  original: {
    tanks: {},
    geos: [],
  },
  filtered: {
    tanks: {},
    geos: [],
  },
  error: Error.NONE,
}

export default handleActions(
  {
    [changeCountry]: (state, { payload: { country } }) => ({
      ...state,
      country,
      zone:''
    }),
    [changeZone]: (state, { payload: { zone } }) => ({
      ...state,
       zone,
       
    }),
    [changeStatus]: (state, { payload: { status } }) => ({
      ...state,
       status,
       
    }),
    [changeProduct]: (state, { payload: { product } }) => ({
      ...state,
      product,
    }),
    [changeType]: (state, { payload: { type } }) => ({
      ...state,
      type,
    }),
    [changeShipTo]: (state, { payload: { sh } }) => ({
      ...state,
      sh,
    }),
    [changeTankId]: (state, { payload: { tankId } }) => ({
      ...state,
      tankId,
    }),
    [changeGeoZones]: (state, { payload: { geoZone } }) => ({
      ...state,
      geoZone,
    }),
    [changeCustomer]: (state, { payload: { customer } }) => ({
      ...state,
      customer,
    }),
    [updateOriginalResult]: (state, { payload: { tanks, geos, error = Error.NONE } }) => ({
      ...state,
      original: {
        tanks,
        geos,
      },
      error,
    }),
    [updateFilteredResult]: (state, { payload: { tanks, geos } }) => ({
      ...state,
      filtered: {
        tanks,
        geos,
      },
    }),
  },
INITIAL_STATE,
)
